import React from "react";
import { useTranslation } from "react-i18next";

export const Spinner = ({ size = "md", className = "" }) => {
  const { t } = useTranslation();
  const sizes = {
    sm: "w-4 h-4 border-2",
    md: "w-6 h-6 border-2",
    lg: "w-8 h-8 border-3",
  };

  return (
    <div
      className={`gpc-spinner ${sizes[size]} ${className}`}
      role="status"
      aria-label={t("ui.spinner.loading")}
    >
      <span className="sr-only">{t("ui.spinner.loading")}</span>
    </div>
  );
};

export const TypingIndicator = () => {
  const { t } = useTranslation();
  return (
    <div
      className="gpc-typing-indicator"
      role="status"
      aria-label={t("ui.typingIndicator.typing")}
    >
      <span className="gpc-typing-dot" />
      <span className="gpc-typing-dot" />
      <span className="gpc-typing-dot" />
    </div>
  );
};